import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from 'react-feather'
import AddExpenseRegister from './AddExpenseRegister'
import DeleteExpenseRegister from './DeleteExpenseRegister'
import ViewExpenseRegister from './ViewExpenseRegister'
import EditExpenseRegister from './EditExpenseRegister'
import ExpenseRegisterModel from './models/ExpenseRegisterModel'
import { logAuditEvent } from '../../utils/auditLogger'

function ExpenseRegisterModal({ onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Expense Register' }) {
  const [childData, setChildData] = useState(new ExpenseRegisterModel() || [])
  const childDataRef = useRef(new ExpenseRegisterModel())
  let modalAction
  let showButtons
  let userAction = reactStringReplace(UserAction, 'User', () => '')

  useEffect(() => {
    if (show) {
      if (selectedRow) {
        const next = { ...selectedRow }
        childDataRef.current = next
        setChildData(next)
      } else {
        const next = new ExpenseRegisterModel()
        childDataRef.current = next
        setChildData(next)
      }
      return
    }
    const reset = new ExpenseRegisterModel()
    childDataRef.current = reset
    setChildData(reset)
  }, [selectedRow, show])

  const handleDataFromChild = (data) => {
    if (typeof data === 'function') {
      setChildData((prev) => {
        const next = data(prev ?? new ExpenseRegisterModel())
        childDataRef.current = next
        return next
      })
      return
    }
    const next = data ?? new ExpenseRegisterModel()
    childDataRef.current = next
    setChildData(next)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const actionDescriptor = UserAction === 'Delete' ? 'Delete Confirm' : 'Save'
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`)
    onSubmit(e, childDataRef.current)
  }

  const handleCancel = (label) => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
    onClose()
  }

  const handleLoad = (data) => {
    const next = data ?? new ExpenseRegisterModel()
    childDataRef.current = next
    setChildData(next)
  }

  if (UserAction === 'Add') {
    modalAction = <AddExpenseRegister onLoad={handleLoad} sendDataToParent={handleDataFromChild} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')}>Cancel</button>
        <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
      </div>
    )
  } else if (UserAction === 'Edit') {
    modalAction = <EditExpenseRegister ExpenseRegisterData={childData} onSubmit={onSubmit} sendDataToParent={handleDataFromChild} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')}>Cancel</button>
        <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
      </div>
    )
  } else if (UserAction === 'View') {
    modalAction = <ViewExpenseRegister ExpenseRegisterData={selectedRow} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>Cancel</button>
      </div>
    )
  } else if (UserAction === 'Delete') {
    modalAction = <DeleteExpenseRegister ExpenseRegisterData={selectedRow} />
    showButtons = (
      <div>
        <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>Cancel</button>
        <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
      </div>
    )
  }

  return (
    UserAction !== 'Delete'
      ? (
        <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
          <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
            <ModalTitle>{userAction} Expense Register</ModalTitle>
          </ModalHeader>
          <ModalBody>{modalAction}</ModalBody>
          <ModalFooter>{showButtons}</ModalFooter>
        </Modal>
      )
      : (
        <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
          <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
            <ModalTitle>
              <div className="custom-alert-icon">
                <Icons.AlertOctagon className="flex-shrink-0" />
              </div>
              <div>{userAction} Expense Register</div>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>{modalAction}</ModalBody>
          <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
        </Modal>
      )
  )
}

export default ExpenseRegisterModal
